import React, {PureComponent, Fragment} from 'react';
import _, {debounce} from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import $ from "jquery";

import FeatureCreatorPageHeader from '../../templates/FeatureCreator/FeatureCreatorPageHeader.rt';
import FeatureCreatorPageFooter from './FeatureCreatorFooterNew';
import {AccessRights} from "../../schemas/accessRightsModel";
import A from './FeatureCreatorNewActions';
import {FeatureCreatorCard} from './FeatureCreatorCardNew';
import {Grid, WindowScroller} from 'react-virtualized';
import {NewFeature} from './NewFeature';
import {filterFeaturesByValues} from "./FeaturesFilters/filtersFunctions";
import {setExpandedFilters, setSelectedFilters} from "./FeaturesFilters/FeaturesFiltersActions";
import {PARTS} from './../../schemas/accessRightsModel';
import { MaxBufferError } from '../../utilities/neat-csv/get-stream';
import {needToSync, UNIT_MEASUREMENTS} from "../../utilities";
import {getApiConfig} from "../../utilities";
import {
  getWizardPopupFeatures
} from "../WizardSetup/WizardPopup/WizardPopupFeaturesExclusion/wizardPopupFeaturesFunctions";
import {getFeaturesStatuses} from "../FeaturesSetup/featuresFunctions";
import FeaturesFilters from "./FeaturesFilters/FeaturesFilters";
import {SortByMode} from "../ProjectScope/SortByMode";

const getGridColumnCount = () => window.innerWidth < 420 ? 1 : Math.floor((window.innerWidth - 100) / 320);

function mapStateToProps(state, props) {
  const {location} = props;
  const {featuresCreatorNew, auth} = state;
  const hasKitchenSub = auth.hasKitchenSub;
  const hasBathroomSub = auth.hasBathroomSub;
  const AR = AccessRights.get(state);
  let enabledFeatures = featuresCreatorNew.enabledFeatures;
  let disabledFeatures = featuresCreatorNew.disabledFeatures;
  const activeMode = featuresCreatorNew.activeMode;
  const applyToFeatures = featuresCreatorNew.applyToFeatures;
  const canEdit = AR.isSiteAdmin(false) || AR.v(PARTS.FAB_CREATE_EDIT_FEATURE);


  if (activeMode !== 'All') {
    if (activeMode === 'Bathroom') {
      enabledFeatures = getWizardPopupFeatures(enabledFeatures, "bathroom");
      disabledFeatures = getWizardPopupFeatures(disabledFeatures, "bathroom");
    } else if (activeMode === 'Kitchen') {
      enabledFeatures = getWizardPopupFeatures(enabledFeatures, "kitchen");
      disabledFeatures = getWizardPopupFeatures(disabledFeatures, "kitchen");
    }
  }

  const selectedFilters = state.featuresFiltersState.selectedFilters;
  if (selectedFilters.length) {
    enabledFeatures = filterFeaturesByValues(enabledFeatures, selectedFilters);
    disabledFeatures = filterFeaturesByValues(disabledFeatures, selectedFilters);
  }

  let group = location.query.group || '';
  let isBacksplashOrCountertop = false;
  let enablePermission = {visible: true, enabled: true};
  switch(group.toLowerCase()) {
    case "countertop":
      enablePermission = AR.checkRights(PARTS.FAB_EDIT_COUNTERTOP);
      isBacksplashOrCountertop = true;
      break;
    case "center island countertop":
      enablePermission = AR.checkRights(PARTS.FAB_EDIT_CENTER_ISLAND_COUNTERTOP);
      isBacksplashOrCountertop = true;
      break;
    case "backsplash":
      enablePermission = AR.checkRights(PARTS.FAB_EDIT_BACKSPLASH);
      isBacksplashOrCountertop = true;
      break;
  }

  let gridColumnCount = getGridColumnCount();
  let disabledSpacer = [];
  if(disabledFeatures.length > 0) {
    let remainder = (((canEdit ? 1 : 0) + enabledFeatures.length) % gridColumnCount);
    if(remainder > 0) {
      for(let i = 0; i < gridColumnCount - remainder; i++) {
        disabledSpacer.push(null);
      }
    }
    disabledSpacer.push("disabled");
    for(let i = 0; i < gridColumnCount - 1; i++) {
      disabledSpacer.push(null);
    }
  }
  let editable = [];
  if(canEdit && enablePermission.visible) {
    editable.push("new");
  }

  let allFeatures = _.concat(editable, enabledFeatures, disabledSpacer, disabledFeatures);
  let disabledIndex = editable.length + enabledFeatures.length + disabledSpacer.length;

  const allUnitMeasurementOptions = [...new Set([
      ...allFeatures.filter(feature => feature && feature.uofM).map(feature => feature.uofM),
    ...UNIT_MEASUREMENTS
  ])].map(option => ({
    value: option,
    label: option
  }));

  return {
    group,
    catId: location.query.catId,
    activeFeaturesGroupName: location.query.group,
    enabledFeatures,
    disabledFeatures,
    allFeatures,
    term: featuresCreatorNew.term,
    AR,
    activeMode,
    showMode: (hasKitchenSub == hasBathroomSub) || AR.isSiteAdmin(false),
    canDelete: true,
    canEdit,
    disabledIndex,
    applyToFeatures,
    enablePermission,
    allUnitMeasurementOptions,
    fabricatorId: auth.fabricatorId,
    isSiteAdmin: AR.isSiteAdmin(true)
  };
}

const debouncedSearchTerm = debounce((dispatch, ...args) => dispatch(A.setSearchTerm(...args)), 300);

function mapDispatchToProps(dispatch, ownProps) {
  return {
    loadFeatures: (groupName, catId) => dispatch(A.loadFeatures(groupName, catId || 0)),
    setMode: mode => dispatch(A.setMode(mode)),
    enableAll: (enable, property) => dispatch(A.enableAll(enable, property)),
    lockAll: lock => dispatch(A.lockAll(lock)),
    setSearchTerm: (...args) => debouncedSearchTerm(dispatch, ...args),
    setSelectedFilters: (selectedFilters) => dispatch(setSelectedFilters(selectedFilters)),
    setExpandedFilters: (expandedFilters) => dispatch(setExpandedFilters(expandedFilters)),
    toggleApplyToFeatures: () => dispatch(A.toggleApplyToFeatures()),
    resetFeatures: () => dispatch(A.resetFeatures())
  };
}

class FeatureCreatorNew extends PureComponent {

  update = () => this.forceUpdate


  constructor(props){
    super(props);

    this.state = {
      syncStarted: false
    }
  }

  componentWillMount() {
    this.props.resetFeatures();
  }

  componentDidMount() {
    document.addEventListener('post-load-project-scope-data', this.update);
    this.props.loadFeatures(this.props.activeFeaturesGroupName, this.props.catId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.term !== nextProps.term || this.props.mode !== nextProps.mode) {
      this.props.loadFeatures(this.props.activeFeaturesGroupName, this.props.catId);
    }
  }

  componentDidUpdate() {
    if(this.props.disabledFeatures.length > 0) {
      let rvg = $('.ReactVirtualized__Grid__innerScrollContainer');
      if(rvg && rvg.css('max-height')) {
        let h = (parseInt(rvg.css('max-height').replace(/[^0-9]/g, '')) - 250).toString() + "px";
        rvg.css('height', h);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('post-load-project-scope-data', this.update);
    this.props.setSearchTerm("");
    this.props.setSelectedFilters([]);
    this.props.setExpandedFilters([]);
    this.props.resetFeatures();
  }

  /*getGridColumnCount = () => window.innerWidth < 420 ? 1 : Math.floor((window.innerWidth - 100) / 320);
  getGridColumnWidth = () => (window.innerWidth - 100) / getGridColumnCount();
  getGridRowCount = (enabled) => Math.ceil(((enabled ? this.props.enabledFeatures : this.props.disabledFeatures).length + (enabled && this.canEdit ? 1 : 0)) / getGridColumnCount());

  getGridItemRenderer = (enabled) => this.gridItemRenderer.bind(this, enabled);

  gridItemRenderer(enabled, {columnIndex, key, rowIndex, style}) {
    let index = (getGridColumnCount() * rowIndex) + columnIndex;
    let feature = (enabled ? this.props.enabledFeatures : this.props.disabledFeatures)[enabled ? index - 1 : index];
    if(index == 0 && enabled && this.props.canEdit) {
      return (
        <NewFeature group={this.props.activeFeaturesGroupName}
                    key={columnIndex + rowIndex} />
      );
    }
    if(feature) {
      return (
        <FeatureCreatorCard
            key={enabled + '_' + key}
            feature={feature}
            groupName={this.props.activeFeaturesGroupName}
            isFromEnabled={enabled}
            style={style}
          />
      );
    }*/

  getGridColumnWidth = () => (window.innerWidth - 100) / getGridColumnCount();
  getGridRowCount = () => Math.ceil(this.props.allFeatures.length / getGridColumnCount());

  gridItemRenderer({columnIndex, key, rowIndex, style}) {
    let index = (getGridColumnCount() * rowIndex) + columnIndex;
    let feature = this.props.allFeatures[index];
    var mutableStyle = {...style} || {};
    if(feature) {
      if(feature == "new") {
        return (
          <NewFeature group={this.props.activeFeaturesGroupName}
                      disabled={!this.props.enablePermission.enabled}
                      key={key} />
        );
      }
      if(feature == "disabled")
      {
        mutableStyle.height = 80;
        mutableStyle.width = '100%';
        return (
          <div style={mutableStyle} key={key}>
            <h1 className="project-scope-disabled-subheader">Disabled Features</h1>
          </div>
        );
      }
      mutableStyle.top = rowIndex * 320;
      if(index >= this.props.disabledIndex) {
        mutableStyle.top -= 250;
      }
      return (
        <FeatureCreatorCard
            key={key}
            feature={feature}
            groupName={this.props.activeFeaturesGroupName}
            isFromEnabled={index < this.props.disabledIndex}
            style={mutableStyle}
            enablePermission={this.props.enablePermission}
            allUnitMeasurementOptions={this.props.allUnitMeasurementOptions}
          />
      );
    }

    return null;
  }

  customOverscanIndicesGetter ({
    direction,          // One of "horizontal" or "vertical"
    cellCount,          // Number of rows or columns in the current axis
    scrollDirection,    // 1 (forwards) or -1 (backwards)
    overscanCellsCount, // Maximum number of cells to over-render in either direction
    startIndex,         // Begin of range of visible cells
    stopIndex           // End of range of visible cells
  }) {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  }

  gridRenderer() {
    if(this.props.canEdit || this.props.allFeatures.length > 0) {
      if(this.props.scrollContainer) {
        return (
          <WindowScroller scrollElement={this.props.scrollContainer}>
            {({ height, isScrolling, onChildScroll, scrollTop, width }) => (
              <Grid
                autoHeight={true}
                cellRenderer={this.gridItemRenderer.bind(this)}
                columnCount={getGridColumnCount()}
                columnWidth={this.getGridColumnWidth()}
                height={height || 0}
                isScrolling={isScrolling}
                onScroll={onChildScroll}
                scrollTop={scrollTop}
                rowCount={this.getGridRowCount()}
                rowHeight={320}
                overscanRowCount={5}
                overscanIndicesGetter={this.customOverscanIndicesGetter}
                width={this.getGridColumnWidth() * getGridColumnCount()}
              />
            )}
          </WindowScroller>
        );
      }
    }
    return null;
  }

  syncGroups = () => {
    this.setState({syncStarted: true});
    getApiConfig('ProjectScope').post({group: this.props.group}, `feature-groups-sync/${this.props.fabricatorId}`).then(r=>{
      this.setState({syncStarted: false});
    });
  }

  render() {
    const {AR, enablePermission, enableAll, lockAll, enabledFeatures, disabledFeatures, applyToFeatures,
      toggleApplyToFeatures} = this.props;
    const {allHaveKv, allHaveKvQt, allHaveBv, allHaveBvQt, allUnlocked}
      = getFeaturesStatuses([...enabledFeatures, ...disabledFeatures]);

    const disabledClass = enablePermission.enabled ? '' : ' disabled';

    return (
      <Fragment>
        <div className="pj-scope-sub-header">
          {(AR.isSiteAdmin(false) || AR.isFabAdmin() || AR.isFabMaster()) ? (
            <div className="pj-scope-sub-header__left">
              {enablePermission.visible ? (
                <Fragment>
                  <div className="en-group">
                    <div className="en-group__title">Enable All</div>
                    <div className="en-group__buttons">
                      <div className="en-panel">
                        <button className={"en-panel__button en-panel__button--kv-vis" + (allHaveKv ? ' on' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(true, 'hasKv') : null}/>
                        <button className={"en-panel__button en-panel__button--kv-qt" + (allHaveKvQt ? ' on' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(true, 'hasQt') : null}/>
                        <span className="en-panel__text">Kitchen</span>
                      </div>
                      <div className="en-panel">
                        <button className={"en-panel__button en-panel__button--bv-vis" + (allHaveBv ? ' on' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(true, 'hasBv') : null}/>
                        <button className={"en-panel__button en-panel__button--bv-qt" + (allHaveBvQt ? ' on' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(true, 'hasBvQt') : null}/>
                        <span className="en-panel__text">Bathroom</span>
                      </div>
                    </div>
                  </div>
                  <div className="en-group">
                    <div className="en-group__title">Disable All</div>
                    <div className="en-group__buttons">
                      <div className="en-panel">
                        <button className={"en-panel__button en-panel__button--kv-vis" + (!allHaveKv ? ' off' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(false, 'hasKv') : null}/>
                        <button className={"en-panel__button en-panel__button--kv-qt" + (!allHaveKvQt ? ' off' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(false, 'hasQt') : null}/>
                        <span className="en-panel__text">Kitchen</span>
                      </div>
                      <div className="en-panel">
                        <button className={"en-panel__button en-panel__button--bv-vis" + (!allHaveBv ? ' off' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(false, 'hasBv') : null}/>
                        <button className={"en-panel__button en-panel__button--bv-qt" + (!allHaveBvQt ? ' off' : '') + disabledClass}
                                onClick={() => enablePermission.enabled ? enableAll(false, 'hasBvQt') : null}/>
                        <span className="en-panel__text">Bathroom</span>
                      </div>
                    </div>
                  </div>
                </Fragment>
              ) : null}
              <div className="en-group">
                <div className="en-group__title">Lock All</div>
                <div className="en-group__buttons">
                  <div className="en-panel">
                    <button className={"en-panel__button en-panel__button--unlock" + (allUnlocked ? ' on' : '')}
                            onClick={() => lockAll(true)} title="Unlock all features"/>
                    <button className={"en-panel__button en-panel__button--unlock" + (!allUnlocked ? ' on' : '')}
                            onClick={() => lockAll(false)} title="Lock all features"/>
                  </div>
                </div>
              </div>
              <div className="en-group">
                <div className="en-group__title">Apply to:</div>
                <div className="en-group__buttons">
                  <div className="en-panel en-panel--single">
                    <button className={"en-panel__button en-panel__button--eye" + (applyToFeatures === 'Enabled' ? ' on' : '')
                      + (applyToFeatures === 'Disabled' ? ' off' : '')}
                      onClick={toggleApplyToFeatures}/>
                    <span className="en-panel__text">{applyToFeatures}</span>
                  </div>
                </div>
              </div>
              {needToSync(this.props.group) && this.props.isSiteAdmin ? (
                <div className="en-group">
                  <div className="en-group__title">Sync All</div>
                  <div className="en-group__buttons">
                    <div className="en-panel en-panel--single">
                      <button className={"en-panel__button en-panel__button--kv-sync " + (this.state.syncStarted ? 'off' : 'on')}
                              onClick={this.syncGroups}/>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
          <div className="pj-scope-sub-header__right">
            <FeaturesFilters/>
            {this.props.showMode ? (
              <SortByMode onItemClick={(item) => this.props.setMode(item)}
                          selectedItem={this.props.activeMode}/>
            ) : null}
          </div>
        </div>
        <div className="lightbox-flex-container lightbox-flex-container--no-margin">
          {this.gridRenderer()}
        </div>
      </Fragment>
    )
  }
}

FeatureCreatorNew.propTypes = {
  activeFeaturesGroupName: PropTypes.string.isRequired,
  loadFeatures: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const FeatureCreatorContainerNew = connector(FeatureCreatorNew);
const FeatureCreatorPageHeaderContainerNew = connector(FeatureCreatorPageHeader);

export {
  FeatureCreatorNew,
  FeatureCreatorContainerNew,
  FeatureCreatorPageHeaderContainerNew,
  FeatureCreatorPageHeader,
  FeatureCreatorPageFooter
};
